module.exports = __webpack_public_path__ + "images/ideation.1f5bf752.webp";